import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SocialPublishAttemptId = Brand<number, 'SocialPublishAttemptId'>;
export const SocialPublishAttemptId = createBranded<SocialPublishAttemptId>();
